/**
 * The security thread along an edge of a surface (direction §6, the `thread-x` and `thread-y`
 * utilities): one per surface, never a divider inside content. The surface must be positioned
 * (`relative`, `sticky` or `fixed`).
 */

/** Down the right edge, just outside the surface's hairline: the rail and the phone sheet. */
export const threadRight =
  "after:pointer-events-none after:absolute after:inset-y-0 after:-right-0.5 after:thread-y";

/** Along the bottom edge: the phone bar and the gate pages' masthead. */
export const threadUnder =
  "after:pointer-events-none after:absolute after:inset-x-0 after:bottom-0 after:thread-x";
